import * as React from 'react';
import { SeatPricingWithQuantity } from '../../classes/seat';
import { getCurrencyFormat } from '../../helpers/currency-format';
import { Html } from '../../helpers/html-helpers';
import { getFocusableChildren, bindKeypress } from '../../helpers/window-helpers';
import DataLoader from '../loader/data-loader';

export interface ISeatFeePreviewModalProps {
    loadingSvgText: string;
    loadingText: string;
    loadedResults: boolean;
    requesting: boolean;
    modalKey: string;
    title: string;
    message: string;
    selectedPricing: Array<SeatPricingWithQuantity>;
    currencyFormat: string;
    priceTypeTextHeadingFormat: string;
    ticketTypeFormat: string;
    ticketCostText: string;
    feeAmountText: string;
    isBestAvailableOnly: boolean;
    cancelString?: string;
    confirmString?: string;
    goToSeatmapString?: string;
    confirmFunction?: any;
    cancelFunction?: any;
    closeFunction?: any;
    goToSeatmapFunction?: any;
    isError?: boolean;
    showModal?: boolean;
    modalClass?: string;
    priority?: number; // only use 1,2 or 3. 1 being highest
}

interface IZoneGroup {
    zoneDescription: string;
    seatGroups: SeatPricingWithQuantity[]
}

class SeatFeePreviewModal<T extends ISeatFeePreviewModalProps> extends React.Component<T, { lastFocused: any }> {

    constructor(props) {
        super(props);
        this.state = { lastFocused: null };
        console.log("Pop-up shown (" + props.modalKey + ")");
    }

    componentDidMount() {
        this.setState({ lastFocused: document.activeElement });
        (document.activeElement as any).blur();
        var modal = document.getElementById('modal-container');
        if (modal != null && this.props.closeFunction != null) {
            let focusableElements = getFocusableChildren(modal);
            window.addEventListener('keydown', event => bindKeypress.bind(this)(event, focusableElements, this.props.closeFunction.bind(this)));
        }
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', bindKeypress.bind(this));
        if (this.state.lastFocused !== null) {
            this.state.lastFocused.focus();
        }
    }

    render() {
        var modalClassName = 'modal-wrapper';

        if (this.props.modalClass) {
            modalClassName = this.props.modalClass + ' modal-wrapper';
        }

        if (this.props.priority) {
            modalClassName = modalClassName + " priority-" + this.props.priority;
        }

        return (
            <div tabIndex={-1} className={modalClassName} id="modal-wrapper" ref="modalWrapper" aria-live="polite">
                <div id="modal-overlay" className="modal-overlay" tabIndex={-1} onClick={this.props.cancelFunction ? () => { this.props.cancelFunction() } : null}></div>
                {this.renderModalContent()}
            </div>
        );
    }

    public seatZoneGroups(): IZoneGroup[] {
        const zoneGroups = [];
        // multiple zones are still tbd but might as well support it
        let selectedZones: string[] = this.props.selectedPricing.map(pricing => pricing.zoneDescription);
        // get unique zones
        selectedZones = selectedZones.filter((zone, index, array) => array.indexOf(zone) === index);
        selectedZones.forEach(zone => {
            const seatsInZone = this.props.selectedPricing.filter(pricing => pricing.zoneDescription === zone);
            zoneGroups.push({
                zoneDescription: zone,
                seatGroups: seatsInZone
            } as IZoneGroup);
        });
        return zoneGroups;
    }

    public renderZone(zone: IZoneGroup, key: number) {
        return (
            <div key={key} className="stack">
                <h3 className="large">{zone.zoneDescription}</h3>
                {
                    zone.seatGroups.map((price, index) => {
                        return (
                            <div key={index}>
                                <p>{this.props.ticketTypeFormat.replace("{0}", price.quantity.toString()).replace("{1}", price.priceTypeDescription)} {getCurrencyFormat(this.props.currencyFormat, price.price + price.feeAmount)}: <strong className="text-dark">{getCurrencyFormat(this.props.currencyFormat, ((price.price + price.feeAmount) * price.quantity))}</strong></p>
                                <div className="small-italic">
                                    <p>{this.props.priceTypeTextHeadingFormat.replace("{0}", price.priceTypeDescription)}</p>
                                    <p>{this.props.ticketCostText} {getCurrencyFormat(this.props.currencyFormat, price.price)}</p>
                                    <p>{this.props.feeAmountText} {getCurrencyFormat(this.props.currencyFormat, price.feeAmount)}</p>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        )

    }

    public renderModalContent() {
        return (
            <section role="dialog" className="modal-container modal-large">
                {this.props.loadedResults ?
                    <div role="document" className="stack">
                        <div className="modal-content stack">
                            <h2 className="heading-general">{this.props.title}</h2>
                            {this.seatZoneGroups().map((zone, key) => this.renderZone(zone, key))}
                        </div>
                        <div dangerouslySetInnerHTML={{ __html: this.props.message }} />
                        <div className="modal-cta-container">
                            {this.props.cancelFunction ? <button className="btn-secondary dialog-cta-left" type="button" onClick={() => { this.props.cancelFunction() }}>{this.props.cancelString}</button> : null}
                            {this.props.goToSeatmapFunction && !this.props.isBestAvailableOnly ?
                                <button className="btn-secondary" type="button" onClick={() => { this.props.goToSeatmapFunction() }}>{this.props.goToSeatmapString}</button>
                                : null
                            }
                            {this.props.confirmFunction ? <button className="btn-primary" type="button" onClick={() => { this.props.confirmFunction() }}>{this.props.confirmString}</button> : null}
                        </div>
                    </div>
                    : null}
                {this.props.requesting ?
                    <div role="document" className="modal-loader">
                        <DataLoader loadingSvgText={this.props.loadingSvgText} loadingText={this.props.loadingText} />
                    </div>
                    : null}
            </section>
        );
    }
}

export default SeatFeePreviewModal;